
  import React from "react"
  import Component from "/Users/dante/Workspace/html_projects/blog/src/layouts/index.jsx"
  import data from "/Users/dante/Workspace/html_projects/blog/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js